import {handleActions} from 'redux-actions';
import {TransferStudent} from '../constants/models';

const  TransferStudentReducers = handleActions({
    SET_TRANSFER_STUDENT: (state, {payload}) => (
        state.merge({
            data: payload
        })
    ),
}, TransferStudent);

export default TransferStudentReducers;


// WEBPACK FOOTER //
// ./src/dashboards_redux/reducers/TransferStudentReducers.jsx